module.exports = __webpack_public_path__ + "static/showreel-poster-9f8d798a54bbc38d34753255f458f69a.jpg";